<template>
  <b-modal class="customer-show-odonto-implant" id="customer-show-odonto-implant" ref="modal" :title="dialog_title"
    hide-footer>


    <div class="form-group row">
      <div class="col-md-12">
        <h6>FECHAS</h6>
      </div>

      <div class="col-md-4">
        <input type="date" id="implant_registration_date" v-model="registration_date" class="form-control">
        <label for="implant_registration_date" class="wabident-info">Fecha Alta</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="implant_attachment_date" v-model="attachment_date" class="form-control">
        <label for="implant_attachment_date" class="wabident-info">Fecha Colocación</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="implant_fail_date" v-model="fail_date" class="form-control">
        <label for="implant_fail_date" class="wabident-info">Fecha Fracaso</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <h6>DATOS DEL IMPLANTE</h6>
      </div>

      <div class="col-md-9">
        <input type="text" id="show_implant_model" v-model="model" class="form-control">
        <label for="show_implant_model" class="wabident-info">Modelo</label>
      </div>

      <div class="col-md-3">
        <single-tooth-selector id="show_implant_tooth" v-model="tooth"></single-tooth-selector>
        <label for="show_implant_tooth" class="wabident-info">Pieza</label>
      </div>

      <div class="col-md-12">
        <textarea id="show_implant_notes" v-model="notes" placeholder="Notas del Implante ..."
          class="form-control"></textarea>
        <label for="show_implant_notes" class="wabident-info">Notas del Implante</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <h6>INFORMACIÓN ADICIONAL</h6>
      </div>

      <div class="col-md-3">
        <input type="date" id="implant_last_revision_date" v-model="last_revision_date" class="form-control">
        <label for="implant_last_revision_date" class="wabident-info">F.Última Revisión</label>
      </div>

      <div class="col-md-3">
        <input type="number" id="implant_next_revision_months" v-model="next_revision_months" min="0" max="200" step="1"
          class="form-control">
        <label for="implant_next_revision_months" class="wabident-info">Próxima Revisión (Meses)</label>
      </div>

      <div class="col-md-12">
        <textarea id="show_implant_complications" v-model="complications" placeholder="Complicaciones del Implante ..."
          class="form-control"></textarea>
        <label for="show_implant_complications" class="wabident-info">Complicaciones del Implante</label>
      </div>

      <div class="col-md-12">
        <textarea id="show_implant_revisions" v-model="revisions" placeholder="Revisiones del Implante ..."
          class="form-control"></textarea>
        <label for="show_implant_revisions" class="wabident-info">Revisiones del Implante</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <h6>ETIQUETAS</h6>
      </div>
      <div class="col-md-6">
        <customer-single-document v-model="sticker_id" :customer="customer" label="Principal"
          deftitle="ETIQUETA IMPLANTE"></customer-single-document>
      </div>
      <div class="col-md-6">
        <customer-single-document v-model="alt_sticker_id" :customer="customer" label="Secundaria"
          deftitle="ETIQUETA IMPLANTE"></customer-single-document>
      </div>
    </div>

    <div class="form-group row mt-5">
      <div class="col text-center">
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar</span>
          <span v-else>Crear</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      is_loading: false,
      implant_id: null,
      sticker_id: null,
      alt_sticker_id: null,
      registration_date: null,
      attachment_date: null,
      fail_date: null,
      model: null,
      tooth: null,
      notes: null,
      last_revision_date: null,
      next_revision_months: 0,
      complications: null,
      revisions: null,
    }
  },
  computed: {
    is_editing() {
      return this.implant_id != null;
    },
    dialog_title() {
      return this.implant_id ? 'Editar Implante' : 'Crear Implante';
    },
    ...mapGetters(['clinic', 'msgwindow'])
  },
  methods: {
    onSubmit() {
      if (this.is_loading) {
        return true;
      }

      this.is_loading = true;
      let params = {
        sticker_id: this.sticker_id,
        alt_sticker_id: this.alt_sticker_id,
        registration_date: this.registration_date,
        attachment_date: this.attachment_date,
        fail_date: this.fail_date,
        last_revision_date: this.last_revision_date,
        tooth: this.tooth,
        notes: this.notes,
        next_revision_months: this.next_revision_months,
        complications: this.complications,
        revisions: this.revisions,
      }

      let uri = `/customer/${this.customer.id}/implants`;
      if (this.is_editing) {
        uri = `/customer/${this.customer.id}/implants/${this.implant_id}`;
        params['_method'] = 'patch';
      }

      axios.post(uri, params)
        .then((response) => {
          this.msgwindow.success('Implante Guardado');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch((error) => {
          this.msgwindow.error('Error guardando Implante. Contacta con el Administrador')
        }).then(() => {
          this.is_loading = false;
        });
    },
    showNew(selected_tooth = []) {
      this.is_loading = false;
      this.implant_id = null;
      this.tooth = selected_tooth[0] || 0;

      this.sticker_id = null;
      this.alt_sticker_id = null;

      this.registration_date = new Date().toISODate();
      this.attachment_date = new Date().toISODate();
      this.fail_date = null;
      this.last_revision_date = null;

      this.tooth = selected_tooth[0] || 0;
      this.model = '';
      this.notes = '';
      this.next_revision_months = 0;
      this.complications = '';
      this.revisions = '';

      this.$refs.modal.show();
    },
    showEdit(implant) {
      this.is_loading = false;
      this.implant_id = implant.id;
      this.sticker_id = implant.sticker_id;
      this.alt_sticker_id = implant.alt_sticker_id;

      this.registration_date = implant.registration_date ? moment(implant.registration_date).format('YYYY-MM-DD') : null;
      this.attachment_date = implant.attachment_date ? moment(implant.attachment_date).format('YYYY-MM-DD') : null;
      this.fail_date = implant.fail_date ? moment(implant.fail_date).format('YYYY-MM-DD') : null;
      this.last_revision_date = implant.last_revision_date ? moment(implant.last_revision_date).format('YYYY-MM-DD') : null;

      this.model = implant.model;
      this.tooth = implant.tooth;
      this.notes = implant.notes;
      this.next_revision_months = implant.next_revision_months;
      this.complications = implant.complications;
      this.revisions = implant.revisions;

      this.$refs.modal.show();
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
#customer-show-odonto-implant {
  .modal-dialog {
    max-width: 40%;
  }
}
</style>
